import { get } from './API';

export default {
  fetchPartners: async () => get('bookings/partners'),
};
